import { LoginCallback } from '@okta/okta-react';
import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Switch, useLocation } from 'react-router-dom';

import { NotFoundPage } from '../NotFoundPage';
import { SecurityProvider } from '../SecurityProvider';
import { UIShell } from '../UIShell';

import RouteWrapper from './RouteWrapper';

// *** REDESIGN BELOW ***
import { AppAdmin } from 'components/AORedesignViews/AppAdmin';
import { BookMgmtReports } from 'components/AORedesignViews/Reports/BookMgmtReports';
import { MarketingResources, Resources, StormResources, TrainingResources, UnderwritingResources } from 'components/AORedesignViews/Resources';
import { RuntimeConfig } from 'components/AORedesignViews/RuntimeConfig';
import { UserAdminHome } from 'components/AORedesignViews/UserAdmin';
import {
  ROUTE_ACCOUNT_ADMIN,
  ROUTE_ACCOUNT_ADMIN_REGISTRATION_MATERIALS,
  ROUTE_BILLING,
  ROUTE_CLAIMS,
  ROUTE_DASHBOARD,
  ROUTE_EMPLOYEE_HOME,
  ROUTE_QUOTES,
  ROUTE_REDESIGN_HOME_MANAGE_CURRENT_PAYMENT,
  ROUTE_REDESIGN_HOME_PAYMENT_BALANCE,
  ROUTE_REDESIGN_HOME_PAYMENT_HISTORY,
  ROUTE_REDESIGN_REPORTS,
  ROUTE_REDESIGN_REPORTS_AGENT_ABSREPORTS,
  ROUTE_REDESIGN_REPORTS_AGENT_APNEREPORT,
  ROUTE_REDESIGN_REPORTS_AGENT_LOSSESBYAGENTREPORTS,
  ROUTE_REDESIGN_REPORTS_AGENT_PLRREPORTS,
  ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_DUE,
  ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_MADE_REPORT,
  ROUTE_REDESIGN_REPORTS_BILLING_PAYMENT_BALANCE_REPORT,
  ROUTE_REDESIGN_REPORTS_BILLING_TAR,
  ROUTE_REDESIGN_REPORTS_BOOK_MANAGEMENT,
  ROUTE_REDESIGN_REPORTS_DIRECT_BILL_COMISSION,
  ROUTE_REDESIGN_RESOURCES,
  ROUTE_REDESIGN_RESOURCES_MARKETING,
  ROUTE_REDESIGN_RESOURCES_STORM,
  ROUTE_REDESIGN_RESOURCES_TRAINING,
  ROUTE_REDESIGN_RESOURCES_UNDERWRITING,
  ROUTE_WILDCARD,
} from 'constants/routes';
import { AccountAdmin } from '../AORedesignViews/AccountAdmin';
import RegistrationMaterials from '../AORedesignViews/AccountAdmin/RegistrationMaterials';
import { Announcements as Announcements_R } from '../AORedesignViews/Announcements';
import { Billing, BillingDetails } from '../AORedesignViews/Billing';
import { FindAnAgent } from '../AORedesignViews/FindAnAgent';
import { NewsAdmin } from '../AORedesignViews/NewsAdmin';
import { ProductDetail } from '../AORedesignViews/ProductDetail';
import { Reports } from '../AORedesignViews/Reports';
import { ABSReport as ABSReport_REDESIGN } from '../AORedesignViews/Reports/AgentReports/ABSReport';
import { APnEReport as APnEReport_REDESIGN } from '../AORedesignViews/Reports/AgentReports/APnEReport';
import { LossesByAgentReport as LossesByAgentReport_REDESIGN } from '../AORedesignViews/Reports/AgentReports/LossesByAgentReport';
import { PolicyLossRunsReport as PolicyLossRunsReport_REDESIGN } from '../AORedesignViews/Reports/AgentReports/PolicyLossRunsReport';
import { DbcReport as DbcReport_REDESIGN } from '../AORedesignViews/Reports/BillingReports/DbcReport';
import { PaymentBalance } from '../AORedesignViews/Reports/BillingReports/PaymentBalance';
import { PaymentsDue } from '../AORedesignViews/Reports/BillingReports/PaymentsDue';
import { PaymentsMade } from '../AORedesignViews/Reports/BillingReports/PaymentsMade';
import { TransactionActivityReports as TransactionActivityReports_REDESIGN } from '../AORedesignViews/Reports/BillingReports/TransactionActivityReports';
import { Claims } from '../Claims';
import { Home } from '../Home';
import { Quotes } from '../Quotes';

// *** LEGACY BELOW ***
import { Clients } from '../AORedesignViews/Clients';
import { HealthChecks } from '../AORedesignViews/HealthChecks';
import { Dashboard } from '../Dashboard';
import { External } from '../External';

import { PaymentBalance as HomePaymentBalance, ManageCurrentPayment, PaymentHistory } from 'components/AORedesignViews/Home';
import {
  ROUTE_BILLING_DETAILS,
  ROUTE_CLIENTS,
  ROUTE_CL_PRODUCT_DETAIL,
  ROUTE_DASH,
  ROUTE_EXTERNAL,
  ROUTE_FIND_AN_AGENT,
  ROUTE_NEWS_ARTICLE_ADMIN,
  ROUTE_REDESIGN_APP_ADMIN,
  ROUTE_REDESIGN_HEALTH_CHECKS,
  ROUTE_REDESIGN_USER_ADMIN,
  ROUTE_RUNTIME_CONFIG,
  ROUTE_R_ANNOUNCEMENTS,
} from '../../constants/routes';

// For scrolling to top after router completes route change
// https://v5.reactrouter.com/web/guides/scroll-restoration
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const RenderedApp = () => (
  <Router>
    <ScrollToTop />
    <SecurityProvider>
      <Switch>
        <RouteWrapper path={ROUTE_DASH} exact component={Dashboard} layout={UIShell} />

        <RouteWrapper path={ROUTE_R_ANNOUNCEMENTS} exact component={Announcements_R} layout={UIShell} />
        <RouteWrapper path={`${ROUTE_CL_PRODUCT_DETAIL}/:productId`} exact component={ProductDetail} layout={UIShell} />
        <RouteWrapper path={`${ROUTE_BILLING_DETAILS}/:accountNumber`} exact component={BillingDetails} layout={UIShell} />
        <RouteWrapper path={ROUTE_NEWS_ARTICLE_ADMIN} exact component={NewsAdmin} layout={UIShell} />
        <RouteWrapper path={ROUTE_EXTERNAL} exact component={External} layout={UIShell} />
        <RouteWrapper path={ROUTE_EMPLOYEE_HOME} exact component={Home} layout={UIShell} />
        <RouteWrapper path={ROUTE_CLIENTS} exact component={Clients} layout={UIShell} />
        <RouteWrapper path={ROUTE_QUOTES} exact component={Quotes} layout={UIShell} />
        <RouteWrapper path={ROUTE_FIND_AN_AGENT} exact component={FindAnAgent} layout={UIShell} />
        <RouteWrapper path={ROUTE_BILLING} exact component={Billing} layout={UIShell} />
        {/* REDESIGN BELOW */}
        <RouteWrapper path={ROUTE_ACCOUNT_ADMIN} exact component={AccountAdmin} layout={UIShell} />
        <RouteWrapper path={ROUTE_CLAIMS} exact component={Claims} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_APP_ADMIN} exact component={AppAdmin} layout={UIShell} />
        <RouteWrapper path={ROUTE_ACCOUNT_ADMIN_REGISTRATION_MATERIALS} exact component={RegistrationMaterials} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_USER_ADMIN} exact component={UserAdminHome} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_HEALTH_CHECKS} exact component={HealthChecks} layout={UIShell} />
        <RouteWrapper path={ROUTE_RUNTIME_CONFIG} exact component={RuntimeConfig} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_HOME_PAYMENT_BALANCE} exact component={HomePaymentBalance} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_HOME_PAYMENT_HISTORY} exact component={PaymentHistory} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_HOME_MANAGE_CURRENT_PAYMENT} exact component={ManageCurrentPayment} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS} exact component={Reports} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_AGENT_ABSREPORTS} exact component={ABSReport_REDESIGN} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_AGENT_APNEREPORT} exact component={APnEReport_REDESIGN} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_AGENT_LOSSESBYAGENTREPORTS} exact component={LossesByAgentReport_REDESIGN} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_AGENT_PLRREPORTS} exact component={PolicyLossRunsReport_REDESIGN} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_BILLING_PAYMENT_BALANCE_REPORT} exact component={PaymentBalance} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_MADE_REPORT} exact component={PaymentsMade} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_DUE} exact component={PaymentsDue} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_BILLING_TAR} exact component={TransactionActivityReports_REDESIGN} layout={UIShell} />
        <RouteWrapper path={`${ROUTE_REDESIGN_REPORTS_BOOK_MANAGEMENT}/:reportType`} exact component={BookMgmtReports} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_REPORTS_DIRECT_BILL_COMISSION} exact component={DbcReport_REDESIGN} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_RESOURCES} exact component={Resources} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_RESOURCES_MARKETING} exact component={MarketingResources} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_RESOURCES_TRAINING} exact component={TrainingResources} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_RESOURCES_UNDERWRITING} exact component={UnderwritingResources} layout={UIShell} />
        <RouteWrapper path={ROUTE_REDESIGN_RESOURCES_STORM} exact component={StormResources} layout={UIShell} />

        {/* order of rendering routes matters */}
        <Route path={`${ROUTE_DASHBOARD}`} component={LoginCallback} />
        <RouteWrapper path={`${ROUTE_WILDCARD}`} component={NotFoundPage} layout={UIShell} />
      </Switch>
    </SecurityProvider>
  </Router>
);

export default RenderedApp;
